<!--
 * @Description: 终端要货清单
 * @Autor: txp
 * @Date: 2021-05-07 16:50:28
-->
<template>
  <div class="announcementview">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="ft20 D1D1D1">分销订单</span>
      </div>
      <div class="select_box flex">
        <div class="select_box_input">
          <el-input
            size="small"
            placeholder="订单编号"
            v-model="orderCode"
            clearable
          ></el-input>
          <el-select
            size="small"
            v-model="approvalStatus"
            clearable
            placeholder="订单状态"
          >
            <el-option
              v-for="item in sfa_approval"
              :key="item.dictCode"
              :label="item.dictValue"
              :value="item.dictCode"
            ></el-option>
          </el-select>
          <el-select
            size="small"
            v-model="orderSource"
            clearable
            placeholder="订单来源"
          >
            <el-option
              v-for="item in sfa_order_source"
              :key="item.dictCode"
              :label="item.dictValue"
              :value="item.dictCode"
            ></el-option>
          </el-select>
          <el-date-picker
            size="small"
            v-model="dataTime"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            class="margintop20"
          ></el-date-picker>
        </div>
        <div class="select_box_btn">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-search"
            @click="queryClick"
          >
            查询
          </el-button>
          <el-button
            size="small"
            type="primary"
            plain
            icon="el-icon-refresh-right"
            @click="resetClick"
          >
            重置
          </el-button>
        </div>
      </div>
      <div class="text item announcementview_content">
        <el-button
          size="small"
          type="primary"
          @click="addOrder"
          class="marginbottom10"
        >
          订单录入
        </el-button>
        <el-button
          size="small"
          type="primary"
          @click="deliveryGoods"
          class="marginbottom10"
        >
          发货
        </el-button>
        <el-button
          size="small"
          type="primary"
          @click="invalid"
          class="marginbottom10"
        >
          作废
        </el-button>
        <el-button size="small" class="marginbottom10" @click="open">
          导出
        </el-button>
        <el-table
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          :header-cell-style="{
            textAlign: 'center',
            fontSize: '13px',
            color: '#787878',
            background: '#F5F5F5',
          }"
          :cell-style="{
            textAlign: 'center',
            fontSize: '14px',
            color: '#1D1D1D',
          }"
          style="width: 100%"
          :data="table_data"
          @selection-change="handleSelectionChange"
        >
          <el-table-column label="全选" type="selection"></el-table-column>
          <template v-for="(item, index) in table_data_head">
            <el-table-column
              v-if="item.prop === 'orderCode'"
              :key="index"
              :width="item.width || '150'"
              :prop="item.prop"
              :label="item.label"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="text"
                  @click="viewDetail(scope.row)"
                >
                  {{ scope.row.orderCode }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              v-else
              :key="index"
              :width="item.width || '150'"
              :prop="item.prop"
              :label="item.label"
            ></el-table-column>
          </template>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.approvalStatus === '1'"
                @click="editRow(scope.row)"
                type="text"
                size="mini"
              >
                编辑
              </el-button>
              <!-- <el-link
                type="primary"
                v-if="scope.row.approvalStatus === '10'"
                :underline="false"
                :href="
                  `/sfa/hdSfaVisitStepOrderDistribution/exportOrderPdf?id=${scope.row.id}`
                "
                style="font-size: 12px"
                >导出</el-link
              > -->
              <el-button
                v-if="scope.row.approvalStatus === '10'"
                @click="print(scope.row)"
                type="text"
                size="mini"
                :loading="printLoading"
              >
                打印
              </el-button>
              <el-button
                v-if="scope.row.approvalStatus === '10'"
                @click="returnOrder(scope.row)"
                type="text"
                size="mini"
                :loading="printLoading"
              >
                退货
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pageschange">
        <el-pagination
          background
          layout="total,prev, pager, next"
          :total="total"
          :current-page.sync="pageNum"
          prev-text="上一页"
          next-text="下一页"
          @current-change="controllerList()"
        ></el-pagination>
      </div>
    </el-card>
    <DistribuiionOrderAdd
      @onSave="closeModeResetClick"
      @onClose="closeModal"
      :modalConfig="modalConfig"
    ></DistribuiionOrderAdd>
    <!-- 导出 -->
    <ExportModal
      v-if="visible"
      :visible="visible"
      :params="modalParams"
      @onClose="close"
    ></ExportModal>
    <!-- 打印模块 -->
    <PrintModal :printConfig="printConfig"></PrintModal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getBatchDictSelect } from '@/api/api'
import request from '@/utils/request'
import DistribuiionOrderAdd from './components/distributionorderAdd.vue'
import ExportModal from '@/components/export_modal/export_modal.vue'
import { getUuid } from '@/utils'
import PrintModal from './components/printModal.vue'
import { Collapse } from 'element-ui'
export default {
  name: 'distributionorder',
  components: { DistribuiionOrderAdd, ExportModal, PrintModal },
  data() {
    return {
      orderCode: '', //订单编号
      orderSource: '', //订单来源
      approvalStatus: '', //订单状态
      dataTime: [], // 订单日期
      table_data_head: [
        { label: '订单日期', prop: 'orderTime', width: 160 },
        { label: '订单编码', prop: 'orderCode', width: 130 },
        { label: '订单状态', prop: 'approvalStatusName', width: 80 },
        { label: '分销单类型', prop: 'orderSourceName', width: 90 },
        { label: '终端名称', prop: 'clientNames' },
        { label: 'KA大仓名称', prop: 'clientName' },
        { label: '业务员', prop: 'realName', width: 80 },
      ],
      table_data: [], // 1.list分页展示接口接受参数
      loading: false,
      pageSize: 10,
      pageNum: 1,
      total: 0,
      selectRow: [], //选中数据
      modalConfig: {
        visible: false,
        data: {},
      },
      sfa_approval: [], //订单状态数据字典
      sfa_order_source: [], //订单来源数据字典
      printConfig: {}, // 打印数据
      printLoading: false, // 打印按钮加载中
      // 导出数据
      visible: false,
      modalParams: {},
    }
  },
  computed: {
    ...mapGetters({
      theme: 'theme',
    }),
  },
  async created() {
    await this.getBatchDictSelect()
  },
  methods: {
    //表格选择事件
    handleSelectionChange(val) {
      this.selectRow = val
    },
    // 获取数据字典
    async getBatchDictSelect() {
      const params = ['sfa_approval', 'sfa_order_source']
      this.loading = true
      getBatchDictSelect(params).then((res) => {
        if (res.success) {
          this.sfa_approval = res.result.sfa_approval
          this.sfa_order_source = res.result.sfa_order_source
          this.controllerList()
        }
      })
    },
    // 获取终端要货列表
    controllerList() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        orderCode: this.orderCode,
        orderSource: this.orderSource,
        approvalStatus: this.approvalStatus,
        createDateAll1: this.dataTime && this.dataTime.length > 0 ? this.dataTime[0] + ' 00:00:00' : '',
        createDateAll2: this.dataTime && this.dataTime.length > 0 ? this.dataTime[1] + ' 23:59:59' : '',
      }
      this.loading = true
      request
        .post('/sfa/hdSfaVisitStepOrderDistribution/findList', params)
        .then(async (res) => {
          this.total = res.result.count

          this.table_data = res.result.data.map((item) => {
            item.approvalStatusName =
              this.sfa_approval.find(
                (itemi) => itemi.dictCode === item.approvalStatus
              ) &&
              this.sfa_approval.find(
                (itemi) => itemi.dictCode === item.approvalStatus
              ).dictValue
            item.orderSourceName =
              this.sfa_order_source.find(
                (itemi) => itemi.dictCode === item.orderSource
              ) &&
              this.sfa_order_source.find(
                (itemi) => itemi.dictCode === item.orderSource
              ).dictValue
            if (item.orderSource === 'order_source_dis_dacang') {
              item.clientNames = ''
            } else {
              item.clientNames = item.clientName
              item.clientName = ''
            }
            return item
          })
          this.loading = false
        })
    },
    //  查询
    queryClick() {
      this.controllerList()
    },
    // 重置
    resetClick() {
      this.pageNum = 1
      this.pageSize = 10
      this.orderSource = ''
      this.orderCode = ''
      this.approvalStatus = ''
      this.controllerList()
    },
    //弹窗关闭重新请求列表
    closeModeResetClick() {
      this.controllerList()
    },

    //关闭弹窗
    closeModal() {
      this.modalConfig.visible = false
    },
    //新增订单
    addOrder() {
      this.modalConfig.data.id = ''
      this.modalConfig.visible = true
      this.modalConfig.data.type = 'add'
    },
    //编辑
    editRow(row) {
      this.modalConfig.data = row
      this.modalConfig.visible = true
      this.modalConfig.data.type = 'edit'
    },
    //查看详情
    viewDetail(row) {
      this.modalConfig.data.id = row.id
      this.modalConfig.visible = true
      this.modalConfig.data.type = 'view'
    },
    // 退货
    returnOrder(row){
      console.log('row===',row)
      let text = ''
      // 分销单类型为TPM活动退货和当月时
      // TPM活动：orderSource：order_source_tpm_act  当月：ext1：'Y'
      if(row.orderSource === 'order_source_tpm_act' && row.ext1 === 'Y'){
        text = '该分销单含折扣商品，是否确认全部退货已选择分销单'
        this.modalConfig.data.isCurrentMonth = true
      }else if(row.ext1 === 'Y'){
        text='是否确认全部退货已选择分销单'
        this.modalConfig.data.isCurrentMonth = true
      }else if(row.orderSource === 'order_source_tpm_act'){
        text='该分销单含折扣商品，非当月分销单只退回库存，是否确认退货已选择分销单'
        this.modalConfig.data.isCurrentMonth = false
      }else{
        text='非当月分销单只退回库存，是否确认退货已选择分销单'
        this.modalConfig.data.isCurrentMonth = false
      }
      this.$confirm(`${text}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(()=>{
        this.modalConfig.data.id = row.id
        this.modalConfig.data.type = 'return'
        this.modalConfig.visible = true
      }).catch(()=>{
        console.log('用户点击取消')
      })
    },
    //发货
    deliveryGoods() {
      if (
        this.selectRow.length !== 1 ||
        this.selectRow[0].approvalStatus !== '1'
      ) {
        this.$message.error('请选择一条已开单状态的分销单数据操作')
        return false
      }
      this.modalConfig.data.id = this.selectRow[0].id
      this.modalConfig.data.type = 'delivery'
      this.modalConfig.visible = true
    },
    //作废
    invalid() {
      const params = {
        ids: this.selectRow.map((item) => item.id),
      }
      request
        .post('/sfa/hdSfaVisitStepOrderDistribution/cancelBatch', params)
        .then((res) => {
          if (res.success) {
            this.$message.success('作废成功')
            this.controllerList()
          }
        })
    },
    // 打开弹框
    open() {
      this.modalParams = {
        sid: getUuid(32, 16),
        functionCode: 'main_list_web',
        parentCode: 'CRM20210711000001767',
        requestUrl: '/sfa/hdSfaVisitStepOrderDistribution/exportOrder',
        orderCode: this.orderCode,
        orderSource: this.orderSource,
        approvalStatus: this.approvalStatus,
        createDateAll1: this.dataTime && this.dataTime.length > 0 ? this.dataTime[0] + ' 00:00:00' : '',
        createDateAll2: this.dataTime && this.dataTime.length > 0 ? this.dataTime[1] + ' 23:59:59' : '',
      }
      this.visible = true
    },
    // 关闭弹框
    close() {
      this.visible = false
      this.modalParams = {}
    },
    // 点击打印按钮
    print(row){
      this.printLoading = true
      request.get(`/sfa/hdSfaVisitStepOrderDistribution/findOrderPdfData`, {id: row.id||''}).then(res=>{
        this.printLoading = false
        if(res.success){
          this.printConfig.value = res.result
          this.printConfig = JSON.parse(JSON.stringify(this.printConfig))
        }
      }).catch(()=>{
        this.printLoading = false
      })
    },
  },
}
</script>
<style lang="scss">
.margintop20{
  margin-top: 20px;
}
.marginbottom10 {
  margin-bottom: 10px;
}
.announcementview {
  width: 1020px;
  height: 100%;
  .el-card {
    height: 100%;
    .el-card__header {
      border-bottom: 0;
      padding: 20px 20px 0px 20px;
    }
    .el-table .success-row {
      background: #fafafa;
    }
    .select_box {
      margin-bottom: 20px;
      .select_box_input {
        flex: 1;
        .el-input {
          width: 200px;
          margin-right: 20px;
        }
        .el-input__inner {
          border-radius: 2px;
          background: #f5f5f5;
        }
        .el-range-input {
          background: #f5f5f5;
        }
        .el-range-editor--small.el-input__inner {
          width: 236px !important;
          margin-right: 20px;
        }
      }
      .select_box_btn {
        width: 240px;
        text-align: right;
      }
    }
    .el-table__fixed-right::before {
      height: 0;
    }
    // 分页
    .pageschange {
      margin: 20px auto;
      text-align: center;
    }
    .el-table__body-wrapper::-webkit-scrollbar {
      height: 5px;
    }
    .el-table__body-wrapper::-webkit-scrollbar-track {
      background-color: #fafafa;
    }
    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background: $color-primary;
    }
  }
}
</style>
